import styled from 'styled-components';

export const PopupWrapper = styled.div`
  height: 100vh;
  width: 100vw;

  position: fixed;
  z-index: 970;

  background-color: rgba(0,0,0,0.6);

  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    max-width: 600px;
  }
`;